import React, { Component } from 'react'

import Header from './Header'
import Footer from './Footer'
import ArtScroller from './ArtScroller'
import Sizing from './Sizing'


class App extends Component {

  render() {
    return (
      <Sizing>
        {/* <div style={style}> */}
        <Header />
        <ArtScroller />
        <Footer />
        {/* </div> */}
      </Sizing>

      // <div className="App">
      //   <div className="App-header">
      //     <ReactFitText>
      //       <p className="App-header-text">
      //         Etta Allean
      //           </p>
      //     </ReactFitText>
      //     <Divider width={'80%'} />
      //   </div>
      //   <div className="App-body">
      //     <Divider hidden />
      //     <ArtCardGroup />
      //   </div >
      //   <div className="App-footer">
      //     (c) 2018 All Rights Reserved
      //   </div>
      // </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js